import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { tiposClientesAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const TiposClientes = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    loadTipos();
  }, []);

  const loadTipos = async () => {
    try {
      setLoading(true);
      const response = await tiposClientesAPI.getAllIncludingInactive();
      if (response.success) {
        setTipos(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar tipos de clientes');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar este tipo de cliente?')) return;

    try {
      const response = await tiposClientesAPI.delete(id);
      if (response.success) {
        toast.success('Tipo eliminado exitosamente');
        loadTipos();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar tipo');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Tipos de Clientes</h1>
        {hasPermission('gestionar_usuarios') && (
          <Link to="/tipos-clientes/nuevo" className="btn-primary">+ Nuevo Tipo</Link>
        )}
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Valor Abono</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tipos.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">No hay tipos de clientes registrados</td>
              </tr>
            ) : (
              tipos.map(tipo => (
                <tr key={tipo.id}>
                  <td><strong>{tipo.nombre}</strong></td>
                  <td className="positive">
                    ${parseFloat(tipo.valor_abono || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                  </td>
                  <td>{tipo.descripcion || '-'}</td>
                  <td>
                    <span className={`badge ${tipo.activo ? 'activo' : 'inactivo'}`}>
                      {tipo.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('gestionar_usuarios') && (
                        <>
                          <Link to={`/tipos-clientes/editar/${tipo.id}`} className="btn-edit">Editar</Link>
                          <button onClick={() => handleDelete(tipo.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TiposClientes;

